export function encode(value: any): string {
  return JSON.stringify(value).replace(/"/g, '·');
}

export function decode<T = any>(encodedJsonString: string): T {
  return JSON.parse(encodedJsonString.replace(/·/g, '"'));
}
